import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

export const SCORECARD_FLAG_KEY = 'scorecard-enabled';

/**
 * Gates `/scorecard` behind the `scorecard-enabled` Amplitude flag.
 * Users without the entitlement are redirected to `/home`.
 */
export const scorecardEnabledGuard: CanActivateFn = async () => {
  const flags = inject(FeatureFlagService);
  const router = inject(Router);
  await flags.ready();
  return flags.isEnabled(SCORECARD_FLAG_KEY) || router.createUrlTree(['/home']);
};
